import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsNCFileConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsNCFileStack = createStackNavigator();

const BatchDetailsNCFileNavigator = () => {
  return (
    <BatchDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchDetailsNCFileConfig.map(({ Component, name }) => (
        <BatchDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsNCFileStack.Navigator>
  );
};

export { BatchDetailsNCFileNavigator };
